import Http from "./base-http";

class UserSkill extends Http {
  addUserSkill(variables) {
    return this.create(variables);
  }
  delUserSkill(id) {
    return this.destroy(id);
  }
}
const userSkill = new UserSkill({
  modelUrlPrefix : "UserSkill"
});
export default userSkill;